import React from "react";
import ScrollReveal from "./ScrollReveal";

const HomePromoBanner = ({
  image,
  title,
  subtitle,
  logo,
  ctaText = "Khám phá ngay",
  link = "/products",
  reverse = false,
  theme = "dark", // 'dark' (for black/red) or 'light' (for blue/white)
}) => {
  const isDark = theme === "dark";
  const textPrimary = isDark ? "text-white" : "text-slate-900 dark:text-white";
  const textSecondary = isDark
    ? "text-slate-300"
    : "text-slate-600 dark:text-slate-400";
  const badgeBg = isDark ? "bg-red-600" : "bg-blue-600";

  return (
    <div className="max-w-7xl mx-auto px-4 py-8 sm:py-10 sm:pb-2">
      <ScrollReveal
        variants={reverse ? "fade-left" : "fade-right"}
        duration={1}
      >
        <div
          className={`relative overflow-hidden rounded-[40px] shadow-2xl group flex items-center h-[320px] sm:h-[520px] ${
            isDark
              ? "bg-gradient-to-br from-slate-950 via-slate-900 to-black"
              : "bg-gradient-to-br from-blue-50 via-white to-slate-100 dark:from-slate-900 dark:via-slate-800 dark:to-slate-950"
          }`}
        >
          {/* Background Image with Overlay */}
          <div className="absolute inset-0">
            <img
              src={image}
              alt={title}
              className={`w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 
                ${isDark ? "opacity-50" : "opacity-80 dark:opacity-40"}`}
            />
            <div
              className={`absolute inset-0 bg-gradient-to-t opacity-90
              ${isDark ? "from-black via-transparent" : "from-white via-transparent dark:from-slate-950 dark:via-transparent"}`}
            />
          </div>

          {/* Content */}
          <div
            className={`relative z-10 w-full px-8 sm:px-24 flex flex-col ${reverse ? "items-end text-right" : "items-start text-left"}`}
          >
            <ScrollReveal variants="fade-up" delay={0.3}>
              <div
                className={`flex items-center gap-4 mb-6 ${reverse ? "flex-row-reverse" : "flex-row"}`}
              >
                {logo && (
                  <img
                    src={logo}
                    alt="TaHa Logo"
                    className="h-8 sm:h-12 w-auto rounded-full border-[1px] border-white object-contain drop-shadow-[0_4px_10px_rgba(0,0,0,0.3)]"
                  />
                )}
                <span
                  className={`inline-block px-5 py-2 ${badgeBg} text-white text-[10px] sm:text-xs font-black uppercase tracking-[0.2em] rounded-full shadow-lg transition-transform hover:scale-110`}
                >
                  Ưu Đãi Đặc Biệt
                </span>
              </div>
            </ScrollReveal>

            <ScrollReveal variants="fade-up" delay={0.5}>
              <h2
                className={`text-4xl sm:text-7xl font-black ${textPrimary} leading-[1.1] mb-5 tracking-tighter drop-shadow-2xl italic uppercase`}
              >
                {title}
              </h2>
            </ScrollReveal>

            <ScrollReveal variants="fade-up" delay={0.7}>
              <p
                className={`text-sm sm:text-xl ${textSecondary} font-semibold max-w-lg mb-10 leading-relaxed`}
              >
                {subtitle}
              </p>
            </ScrollReveal>

            <ScrollReveal variants="fade-up" delay={0.9}>
              <a
                href={link}
                className={`inline-block px-10 py-4 bg-blue-600 text-white rounded-xl font-bold text-xs sm:text-sm uppercase tracking-widest transition-all duration-300 shadow-lg shadow-blue-600/30 hover:-translate-y-1 hover:shadow-2xl active:scale-95
                  ${isDark ? "hover:bg-white hover:text-blue-600" : "hover:bg-slate-900 dark:hover:bg-blue-500"}`}
              >
                {ctaText}
              </a>
            </ScrollReveal>
          </div>

          {/* Decorative Elements */}
          <div
            className={`absolute -bottom-20 ${reverse ? "-left-20" : "-right-20"} w-80 h-80 ${isDark ? "bg-red-600/10" : "bg-blue-400/20"} rounded-full blur-[100px] pointer-events-none`}
          />
          <div
            className={`absolute -top-20 ${reverse ? "-right-20" : "-left-20"} w-80 h-80 ${isDark ? "bg-slate-800/20" : "bg-white/40"} rounded-full blur-[100px] pointer-events-none`}
          />
        </div>
      </ScrollReveal>
    </div>
  );
};

export default HomePromoBanner;
